import { motion } from "framer-motion";

// Fade-up on scroll into view
export function Reveal({ children, delay = 0, y = 40, className = "", once = true, as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}

// Masked line-by-line reveal for large headlines. `tag` controls the wrapper
// element so page heroes can emit a real <h1>.
export function MaskText({ lines = [], className = "", lineClassName = "", lastLineClassName = "", delay = 0, animate, tag = "div" }) {
  const MotionTag = motion[tag] || motion.div;
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "110%" },
    visible: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
  };
  const viewportProps = animate
    ? { animate: "visible" }
    : { whileInView: "visible", viewport: { once: true, margin: "-60px" } };

  return (
    <MotionTag className={className} variants={container} initial="hidden" {...viewportProps}>
      {lines.map((l, i) => (
        <span key={l} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName} ${i === lines.length - 1 ? lastLineClassName : ""}`}
            variants={line}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}
